import createIcon from '../../createIcon';

/**
 * @component @name WifiCalling
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEuNSA0Ljk1QzIxLjI5IDQuNzggMTkuMTcgMyAxNiAzQzEyLjgyIDMgMTAuNzEgNC43OCAxMC41IDQuOTVMMTYgMTJMMjEuNSA0Ljk1WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE5LjUgMTUuNTFDMTguMjYgMTUuNTEgMTcuMDUgMTUuMzEgMTUuOTMgMTQuOTRDMTUuNTggMTQuODIgMTUuMTggMTQuOTEgMTQuOTEgMTUuMThMMTIuNzEgMTcuMzhDOS44OCAxNS45MyA3LjU2IDEzLjYyIDYuMTIgMTAuNzlMOC4zMiA4LjU5QzguNiA4LjMxIDguNjggNy45MiA4LjU3IDcuNTdDOC4yIDYuNDUgOCA1LjI1IDggNEM4IDMuNDUgNy41NSAzIDcgM0gzLjVDMi45NSAzIDIuNSAzLjQ1IDIuNSA0QzIuNSAxMy4zOSAxMC4xMSAyMSAxOS41IDIxQzIwLjA1IDIxIDIwLjUgMjAuNTUgMjAuNSAyMFYxNi41MUMyMC41IDE1Ljk2IDIwLjA1IDE1LjUxIDE5LjUgMTUuNTFaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const WifiCalling = createIcon('WifiCalling', [
  [
    'path',
    {
      d: 'M21.5 4.95C21.29 4.78 19.17 3 16 3C12.82 3 10.71 4.78 10.5 4.95L16 12L21.5 4.95Z',
      key: 'ldzl1j',
    },
  ],
  [
    'path',
    {
      d: 'M19.5 15.51C18.26 15.51 17.05 15.31 15.93 14.94C15.58 14.82 15.18 14.91 14.91 15.18L12.71 17.38C9.88 15.93 7.56 13.62 6.12 10.79L8.32 8.59C8.6 8.31 8.68 7.92 8.57 7.57C8.2 6.45 8 5.25 8 4C8 3.45 7.55 3 7 3H3.5C2.95 3 2.5 3.45 2.5 4C2.5 13.39 10.11 21 19.5 21C20.05 21 20.5 20.55 20.5 20V16.51C20.5 15.96 20.05 15.51 19.5 15.51Z',
      key: '1xh8m4',
    },
  ],
]);

export default WifiCalling;
